//
//
//
//
//
//
//
//
//
//
//
//
//
//


import seo from '~/mixins/seo'
import showcaseQuery from '~/apollo/queries/product/showcase-slug'

export default {
  mixins: [seo],
  // A showcase page needs exactly one ?id=<documentId>. A missing or repeated
  // id (?id=a&id=b arrives as an array) would be sent as an invalid GraphQL
  // variable and rejected with 400 — 404 instead of querying. Legacy numeric
  // ids are 301'd to documentIds by middleware/legacy-id-redirect.js before
  // this runs.
  validate ({ query }) {
    return typeof query.id === 'string' && /^[A-Za-z0-9_-]{1,64}$/.test(query.id)
  },
  apollo: {
    showcase: {
      prefetch: true,
      query: showcaseQuery,
      variables () {
        return { documentId: this.$route.query.id }
      },
      // `data` is undefined when the query errored — guard or the SSR process dies.
      result ({ data }) {
        this.seoCategory = this.$route.params.catslug
        if (data && data.showcase) {
          this.seoTitle = data.showcase.name
        }
      },
      error (error) {
        console.error('[apollo] ' + this.$route.fullPath + ': ' + (error && error.message))
      }
    }
  }
}
